import { render } from "./FacturaPosView.vue?vue&type=template&id=17a37d22"
import script from "./FacturaPosView.vue?vue&type=script&lang=js"
export * from "./FacturaPosView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__